import classNames from 'classnames';
import React from 'react';
import { KeyCode } from '../../types';
import TextFieldBase from '../TextFieldBase/TextFieldBase';
import ITextareaProps from './TextareaProps';

const Textarea = ({ value, onKeyDown, className, ...rest }: ITextareaProps) => {
  function onKeyPress(val: string, event: React.KeyboardEvent) {
    if (event.keyCode === KeyCode.ENTER) {
      event.stopPropagation();
    }
    onKeyDown?.(val, event);
  }

  return (
    <TextFieldBase
      onKeyDown={onKeyPress}
      inputTag="textarea"
      value={value || ''}
      className={classNames('textarea', className)}
      {...rest}
    />
  );
};

export default Textarea;
